import { useMemo, useRef } from 'react';
import { LayerGroup } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.css';
import 'react-leaflet-cluster/dist/assets/MarkerCluster.Default.css';
import useMapProvider from '@casops/components/maps/hooks/useMapProvider';
import * as L from 'leaflet';
import { AssetMarker, AssetMarkerProps } from '../../markers/asset-marker/AssetMarker';
import { SafetyAlertNearbyAssetModel } from '@casops/store/apis/personnelSafetyApi';
import { isPositionModelWithLatLng } from '@cas/types/assets';
interface NearbyAssetsGroupProps {
  assets: SafetyAlertNearbyAssetModel[];
}

export const NearbyAssetsGroup = ({ assets }: NearbyAssetsGroupProps) => {
  const clusterGroupRef = useRef<L.MarkerClusterGroup>(null);
  const { maxZoom, maxNativeZoom } = useMapProvider();
  const minMaxZoom = Math.min(maxZoom, maxNativeZoom);

  const markerProps = useMemo<AssetMarkerProps[]>(() => {
    const markerProps: AssetMarkerProps[] = [];

    for (let i = 0; i < assets.length; i++) {
      const { as: asset, posG, obj } = assets[i];

      if (!isPositionModelWithLatLng(posG)) continue;

      markerProps.push({
        id: asset.id,
        position: [posG.lat, posG.lon],
        heading: posG.hd,
        label: asset.n,
        obj: obj,
      });
    }

    return markerProps;
  }, [assets]);

  return (
    <LayerGroup>
      <MarkerClusterGroup ref={clusterGroupRef} chunkedLoading disableClusteringAtZoom={minMaxZoom}>
        {markerProps.map(({ id, position, heading, label, obj }) => {
          return (
            <AssetMarker
              key={id}
              id={id}
              position={position}
              heading={heading}
              obj={obj}
              label={label}
            />
          );
        })}
      </MarkerClusterGroup>
    </LayerGroup>
  );
};
